<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium"
            >{{ $t('ITEM.EDIT') }} {{ $t('APP_CONTENT.APP_CONTENT') }}</span
          >
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>

    <v-card v-if="error" tile class="mt-5">
      <v-alert
        v-for="(e, index) in error.data.errors"
        :key="index"
        tile
        color="error"
        dark
        dense
        >{{ e[0] }}
      </v-alert>
    </v-card>

    <v-card v-if="Object.keys(localappcontent).length" tile class="pa-5 mt-4">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="validate"
      >
        <v-row>
          <v-col cols="10">
            <v-text-field
              v-model="localappcontent.title"
              class="pr-2"
              :rules="rules.requiredTextLine65"
              :counter="65"
              :label="`${$t('ITEM.TITLE')} *`"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-row>
              <v-select
                v-model="localappcontent.category_id"
                item-value="id"
                item-text="name"
                :items="categories"
                :label="`${$t('ITEM.CATEGORY')} *`"
              ></v-select>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <app-content-tabs
              v-if="Object.keys(localappcontent).length"
              v-model="localappcontent"
              form-path="modules/app_content/components/AppContentHtmlForm.vue"
            ></app-content-tabs>
          </v-col>
        </v-row>
        <v-row class="pr-4">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            :disabled="!valid"
            elevation="24"
            large
            color="success"
            >{{ $t('BUTTON.SAVE') }}</v-btn
          >
        </v-row>
      </v-form>
    </v-card>

    <apps-list class="mt-5" :apps="apps.data" :meta="meta" @refresh="getApps">
    </apps-list>
  </v-container>
</template>

<script>
import { cloneDeep } from 'lodash';
import { requiredTextLine65 } from '@/modules/_global/variables/rules.js';
import AppsList from '@/modules/apps/components/AppsList';
import { mapActions } from 'vuex';
import { HTML } from '@/modules/app_content/common/content-types';

export default {
  name: 'AppContentEditPage',

  components: {
    AppsList,
    AppContentTabs: () =>
      import('@/modules/app_content/components/AppContentTranslationTabs.vue')
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      rules: {
        requiredTextLine65
      },
      error: null,
      valid: true,
      localappcontent: {},
      copyLocalappcontent: null,
      categories: [],
      apps: [],
      meta: {}
    };
  },

  created() {
    this.setData();
  },

  methods: {
    ...mapActions('appcontent', ['retrieveAppsByContentId']),

    validate() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('appcontent/updateHtml', this.localappcontent)
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
            this.$router.push({ name: 'appcontent' });
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    },

    setData() {
      this.$store
        .dispatch('appcontent/retrieveHtml', this.id)
        .then(({ data }) => {
          this.appcontent = data.data;
          this.localappcontent = cloneDeep(this.appcontent);
          this.copyLocalappcontent = cloneDeep(this.appcontent);
        })
        .catch(error => {
          console.log('error');
          this.error = error.response;
        });

      this.$store
        .dispatch('appcontent/retrieveHtmlCategories')
        .then(({ data }) => {
          this.categories = data.data;
        })
        .catch(error => {
          console.log('error');
          this.error = error.response;
        });
    },

    getApps(payload) {
      payload.params.content_id = this.id;
      payload.params.content_type = HTML;

      this.retrieveAppsByContentId(payload).then(data => {
        this.apps = data.data;
        this.meta = data.meta;
      });
    }
  }
};
</script>
